import { Redirect } from 'expo-router';
import { PropsWithChildren } from 'react';

import { NotFound as NotFoundUI } from '@fhs/ui';
import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import useEffectOnce from 'hooks/use-effect-once';
import { usePathname } from 'hooks/use-pathname';
import { useFlag } from 'utils/launchdarkly';
import logger from 'utils/logger';

/**
 * New feature to identify by patterns if a URL non exists in the app
 * need to be redirected to a different section.
 */
const NotFound = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();
  const message = `Not Found: ${pathname}`;
  useRumPageView('not-found', message);

  useEffectOnce(() => {
    /**
     * In the case of React Native, we navigate the user back to the home page
     * If we encounter an unexpected route which leads us to rendering the NotFound component
     */
    logger.warn(message);
  });

  const redirects = useFlag('redirect-old-pages');

  const redirectSearch = redirects.find(item =>
    item.searchPattern.some(pattern => pathname.match(new RegExp(pattern)))
  );

  if (redirectSearch) {
    return <Redirect href={redirectSearch.to} />;
  }

  return children || <NotFoundUI />;
};

export default NotFound;
